import { render, staticRenderFns } from "./ParentCategoryList.vue?vue&type=template&id=1676c285&"
import script from "./ParentCategoryList.vue?vue&type=script&lang=js&"
export * from "./ParentCategoryList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports